import { render, staticRenderFns } from "./SuitabilityProfile.vue?vue&type=template&id=f685180e&scoped=true&"
import script from "./SuitabilityProfile.vue?vue&type=script&lang=ts&"
export * from "./SuitabilityProfile.vue?vue&type=script&lang=ts&"
import style0 from "./SuitabilityProfile.vue?vue&type=style&index=0&id=f685180e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f685180e",
  null
  
)

export default component.exports